import axios from 'axios'
import { AUTO3P_BACKEND_URL } from 'config'

import { APPLICATION_KEY } from '@/utils/config'

import { REPORT_ERROR_PATH } from '@/services/endpoints'

export const sendErrorReport = (errorCode, errorTitle, errorText) => {
  try {
    axios.post(`${AUTO3P_BACKEND_URL}${REPORT_ERROR_PATH}`, {
      appKey: APPLICATION_KEY,
      appVer: VERSION,
      msgCode: errorCode,
      msgHeader: errorTitle,
      msgText: errorText,
    })
  } catch (e) {
    console.error(e)
  }
}
